import { combineReducers } from 'redux';
import chartReducer from './reducer';
import rootSagas from './sagas';
import {
  SCOPE,
  CHART_SCOPE,
  ZOOM_CHART_REQUEST_SCOPE,
  BRUSH_CHART_REQUEST_SCOPE,
  BRUSH_COMPARE_CHART_REQUEST_SCOPE, // primary chart
  SECONDARY_LINE_CHART_REQUEST_SCOPE,
  SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE, // secondary chart
} from './types';

export { default as selectors } from './selectors';

import { createReducer } from '@api/createRequestStore';

export {
  SCOPE,
  CHART_SCOPE,
  ZOOM_CHART_REQUEST_SCOPE,
  BRUSH_CHART_REQUEST_SCOPE,
  BRUSH_COMPARE_CHART_REQUEST_SCOPE,
  SECONDARY_LINE_CHART_REQUEST_SCOPE,
  SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE,
};

export const reducer = combineReducers({
  chart: chartReducer,
  zoomChartRequest: createReducer(ZOOM_CHART_REQUEST_SCOPE),
  brushChartRequest: createReducer(BRUSH_CHART_REQUEST_SCOPE),
  brushCompareChartRequest: createReducer(BRUSH_COMPARE_CHART_REQUEST_SCOPE),
  secondaryLineChartRequest: createReducer(SECONDARY_LINE_CHART_REQUEST_SCOPE),
  secondaryCompareLineChartRequest: createReducer(SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE),
});

export const sagas = [...rootSagas];
